if (!customElements.get('added-notification')) {
  const AddedNotification = class extends HTMLElement {
    connectedCallback() {
      this.dismissOthers();
      this.setProductTitle(this.dataset.productTitle);
      this.display();
    }

    disconnectedCallback() {
      clearTimeout(this.delayedDismissTimeout);
    }

    dismissOthers() {
      document.querySelectorAll('.added-notification').forEach((notification) => {
        if (notification !== this) {
          notification.dismiss();
        }
      });
    }

    setProductTitle(productTitle) {
      this.querySelector('.added-notification__message-title').innerText = productTitle;
    }

    display() {
      // reveal
      setTimeout(() => this.classList.remove('added-notification--hidden'), 10);

      // dismiss after a short period of time
      this.delayedDismissTimeout = setTimeout(this.dismiss.bind(this), 6000);

      // add events to internal links
      this.querySelector('.added-notification__close').addEventListener('click', this.dismiss.bind(this));
      if (theme.settings.cartType === 'drawer') {
        const cartLinks = this.querySelectorAll('.added-notification__message-text a[href$="/cart"]');
        cartLinks.forEach((el) => {
          el.addEventListener('click', (evt) => {
            evt.preventDefault();
            document.querySelector('.js-cart-drawer').open(evt.currentTarget);
            this.dismiss();
          });
        });
      }
           function renderWishlistCounter(swat) {
          var counter_elem = document.querySelectorAll(".swym-wishlist-header-counter"); /* Targets the span added in Step 1. */
          var counter_elem_main = document.querySelector(".swym-header-icon-count-bubble");
          if (counter_elem) {
            for (var i = 0; i < counter_elem.length; i++) {
              if (swat.renderWishlistCount) {
                swat.renderWishlistCount(counter_elem[i], function(count, element) {
                  console.log("debug - renderWishlistCount", count, element); 
                  if(count >0){
                    counter_elem_main.style.display = 'block';
                  }else{
                    counter_elem_main.style.display = 'none';
                  }
                });
              }
            }
          }
        }

        if (!window.SwymCallbacks) {
          window.SwymCallbacks = [];
        }

        window.SwymCallbacks.push(renderWishlistCounter);
        window.SwymCallbacks
    }

    dismiss(evt) {
      if (evt) { evt.preventDefault(); }
      this.classList.add('added-notification--dismissed');
      setTimeout(this.remove.bind(this), 2000);
    }
  };

  window.customElements.define('added-notification', AddedNotification);
}
